module.exports = __webpack_public_path__ + "static/media/NowHere_horizontal_new_font_WHITE_NEW.8aec0e19.png";